import type { PositionOut } from "@/pages/human-resources/time-management/endpoints/reference/domain/inout/PositionOut.ts";
import axios from "axios";

export async function getPositions(domainId: string): Promise<PositionOut[]> {
  const { data } = await axios.get<PositionOut[]>(
    `/api/planning/posts/domains/${domainId}`,
  );
  return data;
}
